<template>
  <div
    v-if="
      currentStatus === 'respondido' || currentStatus === 'Resp. fora do prazo'
    "
    style="padding: 0.375rem 0.75rem"
  >
    <div :class="`flag-status flag-status-respondido`">
      <template>
        {{
          $t(
            `treatments.treatmentTable.dropdown.status.${
              currentStatus === 'Resp. fora do prazo'
                ? 'resp_fora_prazo'
                : 'respondido'
            }`,
          ).toUpperCase()
        }}
      </template>
    </div>
  </div>
  <div
    v-else-if="currentStatus === 'expirado'"
    style="padding: 0.375rem 0.75rem"
  >
    <div :class="`flag-status flag-status-${currentStatus}`">
      {{
        $t(
          `treatments.treatmentTable.dropdown.status.${currentStatus}`,
        ).toUpperCase()
      }}
    </div>
  </div>

  <b-dropdown
    v-else
    size="xl"
    variant="link"
    toggle-class="text-decoration-none"
    no-caret
    @show="onDropdownOpen"
  >
    <template v-slot:button-content>
      <div
        :class="`flag-status flag-status-${
          currentStatus === 'Resp. fora do prazo'
            ? 'resp-fora-prazo'
            : currentStatus
        }`"
      >
        {{ currentStatus.toUpperCase() }}
      </div>
      <span class="sr-only">Search</span>
    </template>

    <div style="overflow: auto; max-height: 350px">
      <b-dropdown-text v-for="(option, i) in options" :key="i">
        <div class="custom-control custom-radio my-1 mr-sm-2">
          <input
            type="radio"
            class="custom-control-input"
            :value="option.value"
            :id="`${idItem}-${i}-status`"
            :name="idItem"
            @change="update(idItem, $event.target.value)"
            :checked="option.value === currentStatus"
          />
          <label class="custom-control-label" :for="`${idItem}-${i}-status`">{{
            option.text
          }}</label>
        </div>
      </b-dropdown-text>
    </div>
  </b-dropdown>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import swal from 'sweetalert';
import api from '../../../services/api';

export default {
  props: {
    currentStatus: { type: String, required: true },
    idItem: { type: String, required: true },
    resurveyId: { type: String },
    review: { type: Number },
  },

  data: () => ({
    userAuth: null,
    options: [],
  }),

  computed: {
    ...mapState('treatments', ['answer', 'summary']),
  },

  methods: {
    ...mapActions('treatments', ['updateStatus']),

    onDropdownOpen() {
      this.getStatus();
    },

    async update(id, newStatus) {
      let oldStatus = '';

      this.answer.forEach((el) => {
        if (el._id === id) {
          oldStatus = el.treatments.status;
          el.treatments.status = newStatus;
        }
      });

      if (this.resurveyId && newStatus === 'respondido') {
        const response = await api.get(`/resurvey/${this.resurveyId}`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });

        const hasResurvey = response.data.resurveyGrades.findIndex(
          (el) => el.grade === this.review && el.value === true,
        );

        if (hasResurvey >= 0) {
          swal({
            title: this.$t('treatments.resurveyWarning.title'),
            text: this.$t('treatments.resurveyWarning.description'),
            icon: 'warning',
            buttons: [
              this.$t('treatments.resurveyWarning.cancelButton'),
              this.$t('treatments.resurveyWarning.saveButton'),
            ],
            dangerMode: true,
          }).then(async (yes) => {
            if (yes) {
              await this.updateStatusProcess(id, newStatus, oldStatus);
            } else {
              this.answer.forEach((el) => {
                if (el._id === id) {
                  el.treatments.status = oldStatus;
                }
              });
            }
          });
        } else {
          await this.updateStatusProcess(id, newStatus, oldStatus);
        }
      } else {
        await this.updateStatusProcess(id, newStatus, oldStatus);
      }
    },

    async updateStatusProcess(id, newStatus, oldStatus) {
      try {
        await this.updateStatus({
          token: this.userAuth.token,
          answerId: id,
          data: { status: newStatus },
        });

        this.updateSummary(oldStatus, newStatus);
      } catch (error) {
        this.answer.forEach((el) => {
          if (el._id === id) {
            el.treatments.status = oldStatus;
          }
        });

        swal(
          'Oops!',
          'Houve um erro inesperado. Tente novamente mais tarde!',
          'error',
        );
      }
    },

    updateSummary(oldStatus, newStatus) {
      if (oldStatus === 'respondido') {
        this.summary.answered -= 1;
      } else if (oldStatus === 'aberto') {
        this.summary.opened -= 1;
      } else if (oldStatus === 'escalonada') {
        this.summary.transfered -= 1;
      } else if (oldStatus === 'em_analise') {
        this.summary.analysis -= 1;
      }

      if (newStatus === 'respondido') {
        this.summary.answered += 1;
      } else if (newStatus === 'aberto') {
        this.summary.opened += 1;
      } else if (newStatus === 'escalonada') {
        this.summary.transfered += 1;
      } else if (newStatus === 'em_analise') {
        this.summary.analysis += 1;
      }
    },

    async getStatus() {
      const response = await api.get('/treatments-status', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.options = response.data;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    // this.options = [
    //   {
    //     value: 'respondido',
    //     text: this.$t('treatments.treatmentTable.dropdown.options.answered'),
    //   },
    //   {
    //     value: 'em_analise',
    //     text: this.$t('treatments.treatmentTable.dropdown.options.analysis'),
    //   },
    //   {
    //     value: 'escalonada',
    //     text: this.$t('treatments.treatmentTable.dropdown.options.staggered'),
    //   },
    //   {
    //     value: 'aberto',
    //     text: this.$t('treatments.treatmentTable.dropdown.options.opened'),
    //   },
    // ];
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.flag-status {
  padding: 0.2rem;
  font-size: 0.8rem;
  border-radius: 0.25rem;
  color: $white;
  width: 100px;
  text-align: center;
  background-color: #5d3fd3;
}

.flag-status-expirado {
  background-color: #c0c0c0;
}

.flag-status-aberto {
  background-color: #dc3545;
}

.flag-status-reaberto {
  background-color: #5d3f58;
}

.flag-status-escalonada {
  background-color: #ffc107;
}

.flag-status-em_analise {
  background-color: #72bcd4;
}

.flag-status-respondido {
  background-color: #28a745;
}

.flag-status-resp-fora-prazo {
  background-color: #28a745;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/dropdown-status/index.vue